import Breakpoints from "../../config/Breakpoints";

export const LuckyNumberHostStyles = `
    scroll-margin-top: 8.375rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

const LuckyNumberStyles = `
    .luckyNumber__footnotes p {
        font-size: var(--font-size-xs);
    }

    @media ${Breakpoints.sm} {
        .luckyNumber__footnotes {
            text-align: center;
        }
    }   

    @media ${Breakpoints.md} {
        .luckyNumber__footnotes {
            max-width: 50rem;
            margin: 0 auto;
        }
    }
`;

export default LuckyNumberStyles;